export interface IPrivateRoutes {
  path: string;
  element: any;
  layout?: any;
}

export enum ServiceType {
  Landlord = "Landlord",
  Listener = "Listener",
  Payment = "Payment",
}
